import { WebWalletCore } from "./WebWalletCore";
import { isMatchingUsers } from "./utils/UserMatching";
import { handleRedirectAndClose } from "./utils/Redirect";
import { canReturnEmail } from "./utils/LoginProviderUtils";
export { SESSION_EVENTS } from "./Constants";
export { isMatchingUsers, handleRedirectAndClose, canReturnEmail };
export const getWallet = (options) => WebWalletCore.getWallet(options);
//# sourceMappingURL=index.js.map